var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadNav'),_c('router-view'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }